import { ExportOutlined, FileTextOutlined, SyncOutlined } from '@ant-design/icons'
import InProgress from '@assets/CustomIcons/orderStatusIcons/truckicon.svg'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import React from 'react'

export function StoreOrderStatusCell({ status, storeId, openDrawer = null, isCompact = false }) {
  switch (status) {
    case null:
      return null
    case 'unset':
      return (
        <OrderStatusButton
          status={status}
          storeId={storeId}
          openDrawer={openDrawer}
          text='Unassigned'
          icon={<FileTextOutlined className='pr-3' />}
          theme='medium'
          isCompact={isCompact}
        />
      )
    case 'assigned':
      return (
        <OrderStatusButton
          status={status}
          storeId={storeId}
          openDrawer={openDrawer}
          text='Scheduled'
          icon={<ExportOutlined className='pr-3' />}
          appearance='outline'
          extraClasses='assigned'
          theme='secondary'
          isCompact={isCompact}
        />
      )
    case 'in progress':
      return (
        <OrderStatusButton
          status={status}
          storeId={storeId}
          openDrawer={openDrawer}
          text='In Progress'
          icon={<SyncOutlined className='pr-3' />}
          appearance='outline'
          theme='secondary'
          isCompact={isCompact}
        />
      )
    default:
      return null
  }
}

function OrderStatusButton({
  status,
  openDrawer,
  storeId,
  text,
  icon,
  appearance,
  extraClasses,
  theme,
  isCompact = false,
}) {
  return (
    <Tooltip title={openDrawer && 'View Site Orders'}>
      <GraviButton
        className={`store-grid-order ${isCompact && 'store-grid-order-compact'} ${extraClasses}`}
        onClick={() => {
          openDrawer?.(storeId)
        }}
        buttonText={
          <div className='flex items-center'>
            <Texto
              appearance={theme}
              weight={theme === 'medium' ? 500 : 'bold'}
              className='pl-1 flex justify-center items-center'
            >
              {icon}
              {text}
            </Texto>
          </div>
        }
        appearance={appearance}
        theme2={status === 'in progress'}
      />
    </Tooltip>
  )
}
